import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME } from './constants';


class ReportRequestApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, API_NAME);
	}

	async CreateReportRequest(name: any, filters: any) {
		const params = {
			Name: name,
			JsonPayload: JSON.stringify(filters),
		};
		return this.post('/Reports/BackgroundReport/CreateReportRequest', params);
	}

	async Download(name: any) {
		return this.downloadXlsxReport(`/Reports/BackgroundReport/StreamFile?filename=${name}`, 'report.xlsx');
	}
}


export const apiProvider = new ReportRequestApi();
